const closeCrossSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="42.907px" height="42.91px" viewBox="0 0 42.907 42.91" enable-background="new 0 0 42.907 42.91" xml:space="preserve">
<g id="Layer_1">
	<g>
		<circle opacity="0.5" fill="#FFFFFF" cx="21.454" cy="21.455" r="21.454"/>
		<path fill="#250E47" d="M25.425,23.871l-2.435-2.422l2.33-2.337c0.412-0.413,0.321-1.12-0.067-1.512
			c-0.413-0.413-1.122-0.459-1.51-0.067l-2.339,2.338l-2.263-2.254c-0.413-0.414-1.093-0.28-1.483,0.111
			c-0.412,0.41-0.435,1.164-0.043,1.553l2.186,2.189l-2.149,2.152c-0.409,0.412-0.34,1.137,0.049,1.529
			c0.165,0.164,0.627,0.621,1.321,0.216l2.369-2.31l2.314,2.313c0.41,0.411,1.147,0.332,1.538-0.058
			C25.408,25.146,25.83,24.564,25.425,23.871z"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;

export default closeCrossSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/closeCrossSVG.js